<template>
  <section
    id="getintouch"
    class="overflow-hidden"
  >
    <v-snackbar
      v-model="snackbar"
    >
      Message has been sent.
    </v-snackbar>
    <v-row
      no-gutters
    >

      <v-col
        class="align-content-space-between layout wrap pt-5"
        cols="12"
        md="6"
        :pa-5="$vuetify.breakpoint.smAndDown"
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="10"
          >
            <base-heading class="mb-5">
              Get In Touch
            </base-heading>

            <v-sheet
              color="transparent"
              max-width="600"
            >
              <p>We’re here to help - send us your questions</p>
              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
                <v-text-field
                  v-model="name"
                  color="info"
                  label="Name"
                  :rules="nameRules"
                  outlined
                  required
                />

                <v-text-field
                  v-model="email"
                  color="info"
                  label="Email"
                  :rules="emailRules"
                  outlined
                  required
                />

                <v-textarea
                  v-model="message"
                  color="info"
                  label="Message"
                  :rules="messageRules"
                  outlined
                  required
                />
                <base-btn
                  @click="send"
                  class="mr-2"
                >
                  Send
                </base-btn>
                <base-btn @click="reset">Reset</base-btn>
              </v-form>
            </v-sheet>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        class="hidden-sm-and-down"
        md="6"
      >
        <v-img
          :src="require('@/assets/contact.jpg')"
          height="100%"
        />
      </v-col>
    </v-row>
  </section>
</template>

<script>
  import emailjs from '@emailjs/browser'

  export default {
    name: 'GetInTouch',
    data: () => ({
      name: '',
      nameRules: [
        v => !!v || 'Name is required',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      message: '',
      messageRules: [
        v => !!v || 'Message is required',
      ],
      valid: true,
      snackbar: false,
    }),
    methods: {
      send: function () {
        if (this.$refs.form.validate()) {
          emailjs.send('limoges_massage_therapy', 'template_az66pn8', { name: this.name, email: this.email, message: this.message }, 's6iMT4HhZjCkkxN2G')
          this.snackbar = true
          this.reset()
        }
      },
      reset: function () {
        this.$refs.form.reset()
      },
    },
  }
</script>
